import React from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp";
import { RequestErrorSnackbarProvider } from "../shared/components/RequestErrorSnackbarProvider";
import { I18nProvider } from "../shared/i18n/i18n";
import { ADMIN_UI_LANGUAGE_STORAGE_KEY } from "../shared/i18n/storageKeys";
import { applyThemeMode, getInitialThemeMode } from "../shared/utils/theme";
import { scheduleAppFontsLoad } from "../shared/utils/loadAppFonts";
import "./admin.css";

const rootElement = document.getElementById("app-root");

if (!rootElement) {
  throw new Error("Missing #app-root element");
}

applyThemeMode(getInitialThemeMode());

createRoot(rootElement).render(
  <React.StrictMode>
    <I18nProvider storageKey={ADMIN_UI_LANGUAGE_STORAGE_KEY}>
      <RequestErrorSnackbarProvider>
        <AdminApp />
      </RequestErrorSnackbarProvider>
    </I18nProvider>
  </React.StrictMode>,
);

scheduleAppFontsLoad();
